/******************************************************************************************
 *	License Delegation Detail Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.licenseDelegationDetailModal', [])
    .factory(
      'LicenseDelegationDetailModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/license-delegation-detail-modal.html',
          controller: 'LicenseDelegationDetailModalController',
          classNames: 'license-delegation-detail-modal'
        });
      }
    )
    .controller('LicenseDelegationDetailModalController', licenseDelegationDetailModalController);
  /* @ngInject */
  function licenseDelegationDetailModalController(
    _,
    $scope,
    ConsumableUsageModal,
    CUSTOMER_SEGMENT,
    LicenseDelegationDetailModal
  ) {
    $scope.isTeamDetails = $scope.customerSegment === CUSTOMER_SEGMENT.TEAM;
    $scope.isEnterpriseDetails = $scope.customerSegment === CUSTOMER_SEGMENT.ENTERPRISE;

    $scope.getConsumableUnits = function(fulfillableItem) {
      return _.get(fulfillableItem, 'units.default', _.get(fulfillableItem, 'chargingModel.unit'));
    };

    /*=== Show License Delegation Detail Modal ===*/
    $scope.showConsumableUsageModal = function(value, consumableItem) {
      var data = $scope.productUsage
        ? {
            consumableItem,
            fulfillableItem: value
          }
        : {
            product: value
          };
      $scope.removeModal();
      ConsumableUsageModal.create(data);
    };

    //Close modal
    $scope.removeModal = function() {
      //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
      LicenseDelegationDetailModal.remove({cancelled: true});
    };
  }
})();
